import { Maybe } from 'yup/lib/types'

import { TokenType } from 'api/domain/auth'

export const tokenToString = (token: Maybe<TokenType>): string => `Bearer ${token}`

export const isTokenExpired = (expire: string) => new Date(expire).getTime() < new Date().getTime()
